var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.7 7.7 5 5.5.6.3c.3 0 .5 0 .7-.2l9.7-10.5c.3-.4.3-.9 0-1.2a.8.8 0 0 0-1.2 0l-9.1 9.9-4.5-5A.8.8 0 1 0 .7 7.8Z"
  })));
};
export default SvgCheck;